// Warm code only after the first screen can paint. Data and authorization still
// load in each screen; no hidden message screen is mounted or marked as read.
export function scheduleNavigationPreload(loaders) {
  if (typeof window === 'undefined' || window.navigator?.connection?.saveData) return () => {}
  let cancelled = false
  const warm = async () => {
    for (const load of loaders) {
      if (cancelled) return
      try { await load() } catch { /* A later navigation can retry the chunk. */ }
    }
  }
  const idle = typeof window.requestIdleCallback === 'function'
  const handle = idle ? window.requestIdleCallback(warm, { timeout: 2000 }) : window.setTimeout(warm, 800)
  return () => {
    cancelled = true
    if (idle) window.cancelIdleCallback?.(handle)
    else window.clearTimeout(handle)
  }
}
